import { Lightning } from '@lightningjs/sdk'

import { getColor, grey50, grey800, grey960 } from '../../constants/colors'

import SpeechComp from '../speechComp/speechComp'
import { SimpleKey } from './CustomKeyboard'
import { KEY_HEIGHT, KEY_WIDTH, SIMPLE_KEY_ROW_COLS } from './keyboardUtils'

export default class Key extends SpeechComp {
  private _rowIndex = 0
  private _index = 0
  private _keyValue: SimpleKey

  static _template() {
    return {
      w: KEY_WIDTH,
      h: KEY_HEIGHT,
      rect: true,
      color: getColor(grey960),
      collision: true,
      flex: {
        justifyContent: 'center',
        alignItems: 'center',
      },
      Label: {
        shader: null,
        text: {
          text: '',
          fontSize: 32,
          textColor: getColor(grey50),
          lineHeight: KEY_HEIGHT,
          verticalAlign: 'middle',
        },
      },
    }
  }

  get label() {
    return this.tag('Label')
  }

  get speechText(): string {
    return this._keyValue
  }

  set index(v: number) {
    this._index = v
  }

  get index() {
    return this._index
  }

  set rowIndex(v: number) {
    this._rowIndex = v
  }

  get rowIndex() {
    return this._rowIndex
  }

  get value() {
    return this._keyValue
  }

  set key(v: SimpleKey) {
    this._keyValue = v

    this.patch({
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: this.getKeyRadius(this._index, this._rowIndex),
      },
    })

    this.label.patch({
      text: {
        text: v,
      },
    })
  }

  _focus() {
    this.patch({
      color: getColor(grey50),
      shader: {
        strokeColor: getColor(grey50),
      },
      Label: {
        text: {
          textColor: getColor(grey960),
        },
      },
    })
    this.speak()
  }

  _unfocus() {
    this.patch({
      color: getColor(grey960),
      shader: {
        strokeColor: getColor(grey800),
      },
      Label: {
        text: {
          textColor: getColor(grey50),
        },
      },
    })
  }

  getKeyRadius(keyIndex, rowIndex) {
    if (keyIndex === 0 && rowIndex === 0) {
      // First key, top left corner
      return [16, 0, 0, 0]
    }

    if (keyIndex === SIMPLE_KEY_ROW_COLS - 1 && rowIndex === 0) {
      // Last key, top right corner
      return [0, 16, 0, 0]
    }

    return 0
  }

  _handleHover() {
    this.fireAncestors('$updateFocusByHover', this)
    this._focus()
  }

  _handleUnhover() {
    this._unfocus()
  }

  _handleKey() {
    this.speak()
    return false
  }
}
